var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useState } from 'react';
import styled from '../../styled';
import IconButton from '../iconButton';
import * as Icons from '../icons';
import Text from '../text';
import * as Tooltip from '../tooltip';
import TooltipView from '../tooltip/TooltipView';
import { useClickAway } from '../../utils';
const IconWrapper = styled.div `
  & > *:before {
    content: '';
    display: block;
    position: absolute;
    top: ${({ direction }) => ['TOP_RIGHT', 'TOP_CENTER', 'TOP_LEFT'].includes(direction)
    ? '-50%'
    : '50%'};
    width: 100%;
    height: 1rem;
  }
`;
const PopoverBox = styled.div `
  width: ${({ width }) => `${width / 16}rem`};
  text-align: left;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.INK_800};
  cursor: default;
`;
const PopoverTitle = styled.div `
  padding: 0.5rem;
  min-height: 1.375rem;
  background-color: ${({ theme }) => theme.colors.SNOW_300};
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  > span {
    word-break: break-all;
  }
`;
const PopoverContent = styled.div `
  padding: 1rem;
  line-height: 1.375rem;
`;
const ChildrenWrapper = styled.div `
  cursor: pointer;
`;
const CloseIconWrapper = styled.div `
  display: inline-flex
  align-items: center;
  margin-left: 0.5rem;
`;
const Overlay = forwardRef((props, ref) => {
    const { width = 320, title, lang = 'en', content, onClose } = props;
    return (React.createElement(PopoverBox, { width: width, ref: ref },
        title && (React.createElement(PopoverTitle, null,
            React.createElement(Text, { weight: "Medium", color: "INK_800", fontType: "Body", lang: lang }, title),
            onClose && (React.createElement(CloseIconWrapper, null,
                React.createElement(IconButton, { handleClick: onClose, size: 1, Icon: Icons.Outline.Cross, iconProps: {
                        size: 'SMALL',
                        color: 'INK_600',
                    }, tooltipProps: {
                        direction: 'TOP_CENTER',
                    } }))))),
        React.createElement(Text, { weight: "Regular", color: "INK_800", fontType: "Body", lang: lang },
            React.createElement(PopoverContent, null, content))));
});
const PopoverClickMode = (props) => {
    const { direction, withPortal, children } = props, restProps = __rest(props, ["direction", "withPortal", "children"]);
    const [isShow, setIsShow] = useState(false);
    const containerRef = useRef(null);
    const childrenWrapperRef = useRef(null);
    const onClose = () => setIsShow(false);
    useClickAway({
        onClickAway: onClose,
        checkIsOutside: (event) => {
            var _a, _b;
            return isShow &&
                !(((_a = childrenWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) ||
                    ((_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target)));
        },
    });
    return (React.createElement(TooltipView, { direction: direction, withPortal: withPortal, lang: restProps.lang, type: "reverse", show: isShow, overlay: React.createElement(Overlay, Object.assign({}, restProps, { ref: containerRef, onClose: onClose })), isArrowHide: true },
        React.createElement(ChildrenWrapper, { ref: childrenWrapperRef, onClick: () => setIsShow(prevIsShow => !prevIsShow) }, children)));
};
const PopoverHoverMode = (props) => {
    const { direction, withPortal, children } = props, restProps = __rest(props, ["direction", "withPortal", "children"]);
    return (React.createElement(Tooltip.Reverse, { direction: direction, withPortal: withPortal, lang: restProps.lang, overlay: React.createElement(Overlay, Object.assign({}, restProps)), isArrowHide: true, delay: 100 },
        React.createElement(IconWrapper, { direction: direction }, children)));
};
const Popover = (_a) => {
    var { triggerType = 'hover' } = _a, restProps = __rest(_a, ["triggerType"]);
    return triggerType === 'hover' ? (React.createElement(PopoverHoverMode, Object.assign({}, restProps))) : (React.createElement(PopoverClickMode, Object.assign({}, restProps)));
};
export default Popover;
//# sourceMappingURL=index.js.map